import { Layout } from 'antd'
import { SiderProps } from 'antd/lib/layout'
import * as React from 'react'
import * as styles from './FixedSidebar.module.less'

const { Sider } = Layout

export interface FixedSidebarProps {
	fixedSidebar?: React.ReactNode
	antdSiderProper?: SiderProps
}

export const FixedSidebar: React.FC<FixedSidebarProps> = (props) => {
	const { antdSiderProper, fixedSidebar } = props

	return (
		<Sider className={styles.fixedSidebar} trigger={null} width='70px' {...antdSiderProper}>
			{fixedSidebar}
		</Sider>
	)
}